export enum TodoState {
    Unchecked,
    Checked,
    Readonly,
    Blocked,
    Disabled,
    Processing,
    Warning,
}
